import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "srcset", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-poster", { 'is-loaded': _ctx.isImageLoaded }])
  }, [
    _createElementVNode("img", {
      width: "100",
      height: "150",
      class: "c-poster__image",
      loading: "lazy",
      src: _ctx.src,
      srcset: _ctx.srcset,
      onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isImageLoaded = true)),
      alt: _ctx.title
    }, null, 40, _hoisted_1),
    (_ctx.type === 'serie')
      ? (_openBlock(), _createBlock(_component_Label, {
          key: 0,
          class: "c-poster__badge",
          isCaption: true,
          isOverlay: true,
          text: "Serie"
        }))
      : _createCommentVNode("", true)
  ], 2))
}